export const assetUrl = (path) => {
  const base = (window.ITSORGANIC_THEME_URL || "").replace(/\/$/, "");
  const cleanPath = String(path).replace(/^\/+/, "");
  return `${base}/assets/${cleanPath}`;
};
